module.exports = __webpack_public_path__ + "static/img/glasses_02.bec86e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/glasses_02.png
// module id = iG/n
// module chunks = 0